import type { ChannelMember } from '@src/api/shared/community/channelMemberApiClient';
import type { Editor } from '@tiptap/react';
import { useCallback } from 'react';

interface UseTiptapKeyboardEventsProps {
  editor: Editor | null;
  channelMembers?: ChannelMember[];
  onSend?: () => void;
  disabled?: boolean;
}

export function useTiptapKeyboardEvents({
  editor,
  onSend,
  disabled = false,
}: UseTiptapKeyboardEventsProps) {
  const handleDeleteKeyAfterMention = useCallback(() => {
    if (!editor) {
      return false;
    }

    const { state } = editor;
    const { selection } = state;

    if (!selection.empty) {
      return false;
    }

    return false;
  }, [editor]);

  // Handle Ctrl+Enter for send
  const handleSendShortcut = useCallback(
    (event: KeyboardEvent) => {
      if (!editor || disabled) {
        return false;
      }

      if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        onSend?.();

        return true;
      }

      return false;
    },
    [editor, disabled, onSend],
  );

  return {
    handleDeleteKeyAfterMention,
    handleSendShortcut,
  };
}
